(function () {
  var icon = document.getElementById('ww-persistent-cart-icon');
  var floating = document.getElementById('ww-persistent-cart-floating');
  var badge = document.getElementById('ww-persistent-cart-badge');
  var floatingBadge = document.getElementById('ww-persistent-cart-floating-badge');
  if (!icon && !floating) return;

  function updateCount(count) {
    [badge, floatingBadge].forEach(function (el) {
      if (!el) return;
      el.textContent = count;
      el.classList.toggle('ww-show', count > 0);
    });
    if (floating) floating.classList.toggle('ww-show', count > 0);
  }

  function openDrawer() {
    if (window.WWCartDrawer && typeof window.WWCartDrawer.open === 'function') {
      window.WWCartDrawer.open();
    }
  }

  if (icon) icon.addEventListener('click', openDrawer);
  if (floating) floating.addEventListener('click', openDrawer);

  // The drawer (assets/ww-cart-drawer.js) broadcasts this on every add/remove/qty
  // change it drives, so the badges stay in sync without their own polling.
  document.addEventListener('ww:cart:updated', function (e) {
    if (e.detail) updateCount(e.detail.item_count);
  });

  // On a fresh page load the drawer hasn't necessarily refreshed yet this view,
  // so fetch the current cart once directly to set the correct initial badge.
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) { updateCount(cart.item_count); })
    .catch(function () {});
})();
